import { bl_applet_config_RowClass } from '../../dbschema/bl_applet_config.model';
import {BaseContainerModel} from '../base-container.model';

export class AppletConfigContainerModel extends BaseContainerModel {
  bl_applet_config: bl_applet_config_RowClass = new bl_applet_config_RowClass();
}
